import * as React from 'react';
import { Grid, MuiBox, Typography } from '@kis-technologies/kis-ui';
import { useStyles } from './TileLayout.styled';
import { TileLayoutProps } from './TileLayout.types';

/**
 * Page layout for a header and content (children).
 */
const TileLayout: React.FC<TileLayoutProps> = (props: TileLayoutProps) => {
  const { headerText, children } = props;

  const classes = useStyles();

  return (
    <Grid container className={classes.outerContainer}>
      <Grid container className={classes.innerContainer}>
        {/* Title */}
        <MuiBox className={classes.headerContainer}>
          <Typography variant="h2">{headerText}</Typography>
        </MuiBox>
        {/* Content */}
        {children}
      </Grid>
    </Grid>
  );
};

export default TileLayout;
